import React from 'react'
import { useCoachChat } from './CoachChatContext'
import { useTranslation } from '~/hooks/useTranslation'
import CandidatesList from './CandidatesList'
import CoachesList from './CoachesList'
import DarkModeToggle from './DarkModeToggle'
import { getSectionHeaderClass } from './coachDashboardStyles'

const VirtualWaitingRoom = ({ candidates, coaches }) => {
  const { getDarkModeClasses } = useCoachChat()
  const { t } = useTranslation('coach_chat')

  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden">
      <div className="mb-4 flex flex-shrink-0 items-center justify-between gap-4">
        <h2 className={getSectionHeaderClass(getDarkModeClasses)}>
          {t('coach_dashboard.virtual_waiting_room', 'Virtual Waiting Room')}
        </h2>
        <DarkModeToggle />
      </div>
      <div
        className="grid min-h-0 flex-1 gap-4 overflow-hidden"
        style={{ gridTemplateRows: 'minmax(0, 1fr) minmax(0, 1fr)' }}
      >
        <CandidatesList candidates={candidates} embedded />
        <CoachesList coaches={coaches} embedded />
      </div>
    </div>
  )
}

export default VirtualWaitingRoom
